import React, { forwardRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { formatAmount, getFullNameUser, numberWithCommas } from '../../Helpers/Utils/Common';

const CategoryPdf = forwardRef(( props, ref ) => {

  return (
  <div ref={ref} className='p-2'>
    <Row>
        <Col>
            <Row>
                <label className='print-text'>{window.company_address1} {window.company_address2}</label>
            </Row>
             <Row>
                <label className='print-text'>DATE FROM: {props.filter.date_from}</label>
            </Row>
             <Row>
                <label className='print-text'>DATE TO: {props.filter.date_to}</label>
            </Row>
            <Row>
                <label className='print-text'>CASHIER: {getFullNameUser()}</label>
            </Row>
        </Col>
    </Row>
    {/* to be condition if button clicked is hourly print category sales report else daily or hourly*/}
    <Row>
        <Col className='d-flex justify-content-start mt-3'>
            <h5><strong>Modifier Sales Report</strong></h5>
        </Col>
        <hr/>
    </Row>
    <Row>
        <Col className='d-flex justify-content-left mb-4'>MODIFIER NAME</Col>
        <Col className='d-flex justify-content-center'>QTY</Col>
        {/* <Col align="right">AMOUNT</Col> */}
        <Col align="right">TOTAL AMOUNT</Col>
    </Row>
    {props.data2.map((data) => {
        return (
            <Row key={data.name}>
                <Col className='d-flex justify-content-left'>{data.menu_name}</Col>
                <Col className='d-flex justify-content-center'>{data.total_qty}</Col>
                {/* <Col align="right">{data.amount ? formatAmount(data.amount) : 0.00}</Col> */}
                <Col align="right">{data.total_amount ? formatAmount(data.total_amount) : 0.00}</Col>
            </Row>
        );
    })}
    {/* <Row className='pt-3'>
        <Col>
            <label className='print-text'><strong>Subtotal:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text'>
            <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label>
        </Col>
        <Col className='d-flex justify-content-end print-text'>
            <label><strong>{props.totals.subtotal}</strong></label>
            Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}
            <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label>
        </Col>
     </Row> */}
     {/* <Row>
        <Col>
            <label className='print-text'><strong>B1T1 Discount:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text'>
            <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label>
        </Col>
        <Col className='d-flex justify-content-end print-text'>
            <label><strong>{props.totals.less_discount}</strong></label>
            Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}
            <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label>
        </Col>
     </Row> */}
     <Row className='mt-4'>
        <Col>
            <label className='print-text'><strong>Grand Total:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text'>
            {/* <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label> */}
        </Col>
        <Col className='d-flex justify-content-end print-text'>
            <label><strong>{formatAmount(props.totals.total_sales)}</strong></label>
            {/* Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")} */}
            {/* <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label> */}
        </Col>
     </Row>
  </div>
)});

export default CategoryPdf;